import * as yup from 'yup';

const validationSchemaBlockedCompanies = yup.object({
  blockedCompany: yup
    .string()
    .matches(
      /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/,
      'Invalid domain name'
    )
    .required('Domain is required'),
});

const validationSchemaPhoneNumber = yup.object({
  countryCode: yup
    .number()
    .required('Country code is required')
    .integer('Country code must be an integer'),
  phone: yup
    .string()
    .required('Phone number is required')
    .matches(/^\d{10}$/, 'Please enter a valid 10-digit number'),
});

const validationSchemaPassword = yup.object({
  password: yup.string().required('Password is required'),
});

const validationSchemaOtp = yup.object({
  otp: yup
    .string()
    .length(6, 'OTP must be exactly 6 digits')
    .required('OTP is required'),
});

export {
  validationSchemaBlockedCompanies,
  validationSchemaPhoneNumber,
  validationSchemaPassword,
  validationSchemaOtp,
};
